import * as React from 'react'

function FailureIcon(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={141.047} height={101.194} viewBox="0 0 141.047 101.194" {...props}>
      <defs>
        <clipPath id="a">
          <path
            data-name="Rectangle 7517"
            transform="translate(3134 18084)"
            fill="none"
            stroke="#707070"
            strokeWidth={1}
            d="M0 0H108V101H0z"
          />
        </clipPath>
      </defs>
      <g data-name="Group 53196">
        <g data-name="Group 51998" transform="translate(-860.117 -295.806) rotate(165.02 431.326 223.988)">
          <circle data-name="Ellipse 1015" cx={4.5} cy={4.5} r={4.5} transform="translate(0 25)" fill="#fe5f55" />
          <circle data-name="Ellipse 1026" cx={3.5} cy={3.5} r={3.5} transform="translate(33 21)" fill="#d3dade" />
          <circle data-name="Ellipse 1025" cx={2} cy={2} r={2} transform="translate(25)" fill="#fe5f55" />
        </g>
        <g data-name="Group 52000" transform="translate(-860.117 -295.806) rotate(35.02 -8.884 1725.435)">
          <circle data-name="Ellipse 1015" cx={3} cy={3} r={3} transform="translate(0 14.988)" fill="#d3dade" />
          <circle data-name="Ellipse 1026" cx={2.5} cy={2.5} r={2.5} transform="translate(18.103 21)" fill="#fe5f55" />
          <circle data-name="Ellipse 1025" cx={1.5} cy={1.5} r={1.5} transform="translate(12.103)" fill="#fe5f55" />
        </g>
        <g
          data-name="Mask Group 131"
          transform="translate(-860.117 -295.806) translate(-2256 -17788)"
          clipPath="url(#a)"
        >
          <path
            data-name="Path 65673"
            d="M35.377 113.009s-1.809 25.746.655 37.883 7.04 42.945 8.2 46.416 2.3 16.566 2.3 16.566-2.626-.493-2.626.979-.162 2.816-.162 3.45-.986 2.457-4.1 6.554-7.386 5.412-7.05 7.212 4.428 2.816 8.526 2.464 7.04-.493 9.349-2.816 5.576-2.95 7.216-3.774 1.964-2.3 1.964-5.414 0-9.349-.162-10.328a35.516 35.516 0 00-.493-5.252c-.655-3.936-2.33-44.086-2.33-44.086s4.928 31.815 6.723 36.736 3.443 11.806 3.443 11.806-.979 2.816 0 4.59 3.45 6.4 3.45 6.4 1.148 7.04 1.8 10.5 5.738 6.723 7.378 5.576a8.16 8.16 0 003.774-8.695c-.986-4.921-2.3-7.378-2.816-10.5s1.64-7.04.986-9.673-1.148-1.64-1.64-5.576-.493-25.915-1.971-32.308-3.112-17.22-3.112-17.22.324-26.049.324-26.9.331-10.166.331-10.166-12.468 3.443-22.8.824a172.579 172.579 0 01-17.157-5.248z"
            fill="#263238"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(2556.49 17980.461) translate(572.51 112.421)"
          />
          <path
            data-name="Path 65676"
            d="M31.357 46.542a44.818 44.818 0 00-2.471 10.335c-.451 5.062-3.26 21.121-3.26 21.121S12.872 95.612 10.742 95.762c0 0 26.67-.478 26.9-.816s-3.246-46.179-3.471-47.3-2.814-1.104-2.814-1.104z"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(2556.49 17980.461) translate(572.51 112.421)"
          />
          <path
            data-name="Path 65677"
            d="M29.914 80.485a8.47 8.47 0 00-4.295-2.478 13.988 13.988 0 013.154 4.492"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(2556.49 17980.461) translate(572.51 112.421)"
          />
          <path
            data-name="Path 65682"
            d="M34.138 108.602v7.885s10.293 4.815 20.846 5.344a102.878 102.878 0 0022.184-1.869l.134-70.4s-7.35-3.745-14.165-4.816-27.126 2.006-27.126 2.006z"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(2556.49 17980.461) translate(572.51 112.421)"
          />
          <path
            data-name="Path 65683"
            d="M50.464 33.173s-1.577 16.193-1.126 17.192a6.864 6.864 0 006.294 3.7c3.936 0 8.2-4.154 8.2-4.154l1.352-16.3s-5.175 2.478-8.765 1.69a23.157 23.157 0 01-5.956-2.133z"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(2556.49 17980.461) translate(572.51 112.421)"
          />
          <path
            data-name="Path 65684"
            d="M46.81 19.571s-1.119-2.584-2.246-.563 2.584 7.2 2.584 7.2z"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(2556.49 17980.461) translate(572.51 112.421)"
          />
          <path
            data-name="Path 65685"
            d="M68.368 19.571s1.119-2.584 2.246-.563-3.161 7.526-3.161 7.526z"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(2556.49 17980.461) translate(572.51 112.421)"
          />
          <path
            data-name="Path 65686"
            d="M638.976 139.654a38.117 38.117 0 01-1.126-5.175c0-1.126 2.028-1.119 2.028-1.119z"
            transform="translate(2556.49 17980.461) translate(572.51 112.421) translate(-591.849 -118.619)"
            fill="#263238"
          />
          <path
            data-name="Path 65687"
            d="M47.282 15.192s-.394 13.919.655 16.15 4.724 7.35 5.632 8 4.069.922 4.992.789 7.956-7.153 8.216-8.068 1.366-13.728 1.366-13.728l-.127-10.631a12.947 12.947 0 00-6.569-1.183c-3.943.26-13.658 4.464-13.658 4.464z"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(2556.49 17980.461) translate(572.51 112.421)"
          />
          <path
            data-name="Path 65688"
            d="M654.528 122.206s-3.288 4.337-4.731 4.992-1.183-2.112-1.183-2.112a22.909 22.909 0 01-8.272 3.682c-4.858 1.049-8.793 1.31-10.11-.528s2.887-4.464 2.887-4.464-3.281-1.971 0-5.513 11.687-7.491 17.727-5.125 4.858 4.6 4.858 4.6 4.6-.655 4.992 3.02-2.365 7.878-2.365 7.878-.127 3.154-.127 3.935-.922.662-.922.662l-.394-3.943s-1.443.134-2.232-2.626a7.532 7.532 0 01-.128-4.458z"
            transform="translate(2556.49 17980.461) translate(572.51 112.421) translate(-589.519 -112.421)"
            fill="#263238"
          />
          <path
            data-name="Path 65689"
            d="M54.837 27.336a3.259 3.259 0 001.695.739 3.066 3.066 0 001.621-.665"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(2556.49 17980.461) translate(572.51 112.421)"
          />
          <path
            data-name="Path 65690"
            d="M54.199 33.3a3 3 0 013.069 0c1.789.924 2.484.427 2.484.427"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(2556.49 17980.461) translate(572.51 112.421)"
          />
          <path
            data-name="Path 65692"
            d="M54.391 18.585s-3.619-.154-4.966 2.238"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(2556.49 17980.461) translate(572.51 112.421)"
          />
          <path
            data-name="Path 65705"
            d="M59.653 18.583s3.62-.154 4.966 2.239"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(2556.49 17980.461) translate(572.51 112.421)"
          />
          <path
            data-name="Path 65693"
            d="M647.638 142.212c0 .739-.331 1.345-.7 1.345s-.7-.605-.7-1.345.331-1.352.7-1.352.7.605.7 1.352z"
            transform="translate(2556.49 17980.461) translate(572.51 112.421) translate(-594.329 -120.839)"
            fill="#263238"
          />
          <path
            data-name="Path 65694"
            d="M659.688 142.212c0 .739-.324 1.345-.7 1.345s-.7-.605-.7-1.345.331-1.352.7-1.352.7.605.7 1.352z"
            transform="translate(2556.49 17980.461) translate(572.51 112.421) translate(-597.896 -120.839)"
            fill="#263238"
          />
          <path
            data-name="Path 65695"
            d="M85.222 116.683a41.223 41.223 0 00-2.112 4.548c-.218.943 0 4.168-.19 5.879s-1.605 2.274-.662 3.027 2.464-.753 2.816-1.408.852-1.985 1.324-3.027 1.042.852 1.331 1.408.092 6.252.19 7.2-1.141 4.456-.76 5.118 1.232.662 1.612-.282a29.484 29.484 0 011.514-2.816s5.02-4.168 5.491-4.83-1.985-9.666-2.175-11.18-.57-3.886-.57-3.886z"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(2556.49 17980.461) translate(572.51 112.421)"
          />
          <path
            data-name="Path 65696"
            d="M90.34 136.283a25.9 25.9 0 001.324-3.6c.19-1.042.38-2.464.479-2.753"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(2556.49 17980.461) translate(572.51 112.421)"
          />
          <path
            data-name="Path 65697"
            d="M91.382 135.347a12.831 12.831 0 002.112-3.027c.218-.915.38-2.112.38-2.112"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(2556.49 17980.461) translate(572.51 112.421)"
          />
          <path
            data-name="Path 65698"
            d="M85.074 113.854l.148 2.816s1.331 1.408 4.738 1.711 4.548-1.331 4.548-1.331l.225-2.429s-7.54.093-9.659-.767z"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(2556.49 17980.461) translate(572.51 112.421)"
          />
          <path
            data-name="Path 65699"
            d="M64.622 39.572s-4.724 15.172-6.294 28.541-1.126 46.747-1.126 46.747 2.366.788 10.455.7 11.912-1.232 11.912-1.232l1.035-33.406 5.731 7.977-1.232 24.951a5.8 5.8 0 004.041 1.8 13.9 13.9 0 006.625-.95s2.478-26.049 2.366-28.041-14.158-36.405-15.277-37.531-15.059-8.2-15.059-8.2-1.607-2.81-3.177-1.356z"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(2556.49 17980.461) translate(572.51 112.421)"
          />
          <path
            data-name="Path 65700"
            d="M67.77 40.923s.338 3.6.338 8.2a72.848 72.848 0 01-.7 9.216 9.723 9.723 0 00-4.928.113c-2.478.788-3.034 1.683-3.034 1.683s3.478-18.3 5.168-20.564 2.254-.556 3.156 1.352z"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(2556.49 17980.461) translate(572.51 112.421)"
          />
          <path
            data-name="Path 65701"
            d="M80.603 80.926s-6.85-8.878-6.4-12.588 1.119-7.744 1.119-7.744"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(2556.49 17980.461) translate(572.51 112.421)"
          />
          <path
            data-name="Path 65702"
            d="M49.564 39.572S48.219 57.327 46.98 65.98s-.451 47.986-.451 47.986a47.074 47.074 0 01-9.1-1.915 64.57 64.57 0 01-6.738-2.584l.443-23.824s-.894-37.975.225-39.1 14.383-4.928 14.383-4.928 2.477-2.381 3.822-2.043z"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(2556.49 17980.461) translate(572.51 112.421)"
          />
          <path
            data-name="Path 65703"
            d="M45.741 41.6s-1.457 5.168-2.816 9.547a50.157 50.157 0 00-1.683 6.745 2.316 2.316 0 013.372-.451 30.141 30.141 0 013.26 2.7l1.9-20.55a4.224 4.224 0 00-4.034 2.014z"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(2556.49 17980.461) translate(572.51 112.421)"
          />
          <path
            data-name="Path 65704"
            d="M90.502 86.668a8.421 8.421 0 00-4.182 2.272 12.844 12.844 0 015.124-.335"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(2556.49 17980.461) translate(572.51 112.421)"
          />
        </g>
      </g>
    </svg>
  )
}

export default FailureIcon
